<mat-dialog-content>
  <h2>Copy Workout</h2>
  <p>Please select a date to copy workout from.</p>
  
  <mat-calendar [(selected)]="data.date"></mat-calendar>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" [mat-dialog-close]="null">CANCEL</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="data.date">OK</button>
</mat-dialog-actions>